import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as Sentry from "@sentry/angular";
import { environment } from "../../../environments/environment";
import { UserModel } from "../models/user-model";
import { DialogService } from "./dialog.service";

@Injectable({
  providedIn: "root",
})
export class SentryService {
  public sentry = Sentry;
  private scope = new Sentry.Scope();
  private userData: UserModel;
  constructor(
    private dialogService: DialogService,
    private _snackBar: MatSnackBar
  ) {
    if (!this.userData) {
      if (typeof Storage !== "undefined") {
        if (localStorage.getItem("userData")) {
          this.userData = JSON.parse(localStorage.getItem("userData"));
        }
      }
    }
  }

  /**
   * Report errors to sentry, while also printing an error if !environment.production
   */
  errorHandling(
    errorMessage: any,
    section: string,
    alertMessage?: string
  ): void {
    const errorsArray = [
      "Unexpected end of JSON input",
      "getClientRect",
      "clientRect",
      "Username and Pool information are required",
      "graph.instagram.com",
      "Non-Error exception captured with keys",
      "Http failure response for",
      "_reportEvent",
      "nativeElement",
      "https://api.sitecreator.io/v1/getSiteByRoute",
      "animation",
      "saveNewImage",
      "postAnalytics",
      "InvalidAccessError",
      "getSiteByRoute",
      "during parsing",
      "LatLng",
      "NaN, NaN",
      "not allowed by the user agent",
      "NotAllowedError",
      "UnhandledRejection",
      "promise rejection captured",
    ];
    let exist = false;
    errorsArray.forEach((err) => {
      if (!exist) {
        exist = errorMessage.message.includes(err);
      }
    });
    if (section) this.scope = this.scope.setTag("section", section);
    if (this.userData) {
      if (this.userData.email)
        this.scope.setUser({ email: this.userData.email });
      if (this.userData.name)
        this.scope.setUser({ username: this.userData.name });
    }

    if (!exist) {
      /** Check if error or regular message */
      if (errorMessage instanceof Error) {
        this.sentry.captureException(errorMessage, this.scope);
      } else if (errorMessage instanceof HttpErrorResponse) {
        /** Check if Http Error and fix the message */
        let formattedErrorMessage = "Error " + errorMessage.status + ": ";
        if (errorMessage.error && errorMessage.error.message)
          formattedErrorMessage =
            formattedErrorMessage + errorMessage.error.message;
        formattedErrorMessage += errorMessage.message;
        this.scope.setLevel(Sentry.Severity.Warning);
        this.sentry.captureMessage(formattedErrorMessage, this.scope);
      } else {
        if (typeof errorMessage == "object")
          errorMessage = JSON.stringify(errorMessage);
        this.sentry.captureMessage(errorMessage, this.scope);
      }

      if (!environment.production)
        console.error(
          section
            ? "Error in " + section + ": " + errorMessage.message
            : "Error: " + errorMessage.message
        );
      if (alertMessage) {
        // this.presentAlert(alertMessage);
      }
    }
  }

  async presentAlert(message: string) {
    this.openSnackBar(message);
  }

  openSnackBar(message) {
    this._snackBar.open(message, "", {
      duration: 5 * 1000,
      verticalPosition: "top",
      horizontalPosition: "center",
    });
  }
}
